import { useParams, useSearchParams } from 'react-router-dom';
import Message from '../../components/layout/Message';
import Meta from '../../components/layout/Meta';
import { Row, Container } from 'react-bootstrap';
import ProductCard from '../../components/product/ProductCard';
import Paginate from '../../components/ui/Paginate';
import { useGetProductsByCategoryIdQuery } from '../../slices/productApiSlice';
import { useGetCategoryByIdQuery } from '../../slices/categoryApiSlice';
import { useSelector } from 'react-redux';
import SortSelect from '../../components/ui/SortSelect';
import ProductCardSkeleton from '../../components/ui/ProductCardSkeleton';
import ActiveGlobalDiscountBanner from '../../components/ui/ActiveGlobalDiscountBanner';
import ShippingBehaviorBanner from '../../components/ui/ShippingBehaviorBanner';

const CategoryProductsScreen = () => {
    const { userInfo } = useSelector((state) => state.auth);
    const { categoryId, pageNumber } = useParams();

    const [searchParams] = useSearchParams();
    const sort = searchParams.get('sort') || '';

    const page = pageNumber || 1;

    const { data, isLoading, isFetching, error } = useGetProductsByCategoryIdQuery({
        categoryId,
        pageNumber: page,
        priceAssigned: userInfo?.priceAssigned || null,
        sort,
    });

    const { data: categoryData } = useGetCategoryByIdQuery(categoryId, {
        skip: !categoryId,
    });

    const products = data?.products || [];
    const categoryName =
        categoryData?.name ||
        categoryData?.category?.name ||
        data?.categoryName ||
        products.find((product) => product?.category?.name)?.category?.name ||
        '';
    const categoryImage =
        categoryData?.image ||
        categoryData?.category?.image ||
        data?.categoryImage ||
        data?.category?.image ||
        products.find((product) => product?.category?.image)?.category?.image ||
        '/images/default.jpg';

    return (
        <Container className="py-4">
            <Meta title={categoryName} />
            <ActiveGlobalDiscountBanner allowGuestPrompt />
            <ShippingBehaviorBanner />

            <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 mb-4 p-3 p-md-4 border rounded-4 bg-light">
                <div className="d-flex align-items-center gap-3 flex-grow-1">
                    <img
                        src={categoryImage}
                        alt={categoryName || 'Categoria'}
                        onError={(e) => {
                            e.currentTarget.onerror = null;
                            e.currentTarget.src = '/images/default.jpg';
                        }}
                        style={{ width: '64px', height: '64px', objectFit: 'cover', borderRadius: '12px', flexShrink: 0 }}
                    />
                    <div>
                        <p className="text-muted mb-1 small">Categoria mostrada</p>
                        <h1 className="mb-0 section-title">{categoryName}</h1>
                    </div>
                </div>
                <div style={{ minWidth: '200px' }}>
                    <SortSelect currentSort={sort} />
                </div>
            </div>

            {isLoading || isFetching ? (
                <Row className="mx-0">
                  <div className="ProductGrid">
                    {[...Array(8)].map((_, idx) => (
                      <ProductCardSkeleton key={idx} />
                    ))}
                  </div>
                </Row>
            ) : error ? (
                <Message variant="danger">
                    {error?.data?.message || error?.error || 'Something went wrong'}
                </Message>
            ) : (
                <>
                    {products.length === 0 ? (
                        <div className="text-center py-5 bg-light rounded-4 border">
                            <p className="text-muted mb-0">No hay productos disponibles en esta categoria.</p>
                        </div>
                    ) : (
                        <>
                            <Row className="mx-0">
                                <div className="ProductGrid">
                                    {products.map((product) => (
                                        <ProductCard product={product} key={product._id} />
                                    ))}
                                </div>
                            </Row>
                            <div className="mt-4">
                                <Paginate
                                    pages={data.pages}
                                    page={data.page}
                                    categoryId={categoryId}
                                    categoryName={categoryName}
                                    sort={sort}
                                />
                            </div>
                        </>
                    )}
                </>
            )}
        </Container>
    );
};

export default CategoryProductsScreen;
